import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUa'
})
export class FormatUaPipe implements PipeTransform {
  transform(ua: string): string {
    return ua.padEnd(7, '0');
  }
}